import React, { Fragment } from "react";
import { Badge } from "reactstrap";

import CrowdContentOrderAccordion from "./components/CrowdContentOrderAccordion";

// local imports
import {
  AddContentOrderModal,
  AddCrowdContentOrderModal,
  DecideContentOrderProviderModal,
  ViewContentOrderStatsModal,
} from "../modals";

const CrowdContentOrderCard = (props) => {
  const { crowdContentOrders, activateModal } = props;
  return (
    <Fragment>
      <div
        className={
          crowdContentOrders.length > 0 ? "col-12 pt-2 pb-3" : "col-12 pt-2"
        }
      >
        <div className="text-right">
          <Badge
            href="#"
            color="success"
            onClick={() => activateModal("decideContentOrderProviderModal")}
          >
            New Order
          </Badge>
        </div>
      </div>
      {crowdContentOrders.length === 0 ? <hr /> : <Fragment />}

      {crowdContentOrders.length === 0 ? (
        <div className="text-center pb-2">
          <em>There are currently no Stellar Content orders on this account.</em>
        </div>
      ) : (
        crowdContentOrders.map((date) => (
          <CrowdContentOrderAccordion
            date={date.orderDate}
            orders={date.orders}
          />
        ))
      )}
      <AddContentOrderModal />
      <AddCrowdContentOrderModal />
      <DecideContentOrderProviderModal />
      <ViewContentOrderStatsModal contentOrderProvider="crowdContent" />
    </Fragment>
  );
};

export default CrowdContentOrderCard;
